// app/[locale]/contact/page.tsx
"use client";
import { Link } from "@/i18n/navigation";
import { useLocale } from "next-intl";
import { Mail, MessageCircle, Zap, ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useTranslations } from "next-intl";
import { toast } from "sonner";



export default function ContactPage() {
  const locale = useLocale();
  //const t = getLabels(locale);
  const t = useTranslations("about.contact")
  const tc = useTranslations("common");
  const copyEmail = (email: string) => {
    navigator.clipboard?.writeText(email).then(() => toast.success(tc("emailCopied")), () => {});
  };
  const rows = t.raw("rows") as { action: string; energy: string }[];

  return (
    <>
     <Navbar />
      <div className="min-h-screen bg-white pt-32">
        <div className="max-w-6xl mx-auto px-6 py-16 lg:py-24">
        {/* Header — зеркальный Linear */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 mb-16">
          {/* Right колонка (текст) — на десктопе справа */}
          <div className="lg:order-2">
            <h1 className="text-3xl lg:text-4xl font-semibold text-slate-900 tracking-tight mb-4">
              {t("titlecontact")}
            </h1>
            <p className="text-base text-slate-500 leading-relaxed max-w-md">
              {t("sub")}
            </p>
          </div>

          {/* Left колонка (карточки) — на десктопе слева */}
          <div className="lg:order-1 grid sm:grid-cols-2 gap-4">
            {/* Feedback card */}
            <a
            href={`mailto:${t("feedbackEmail")}`}
              onClick={() => copyEmail(t("feedbackEmail"))}
              className="group flex flex-col p-8 rounded-2xl border border-slate-200 bg-white hover:border-blue-300 hover:shadow-md transition-all min-h-[220px]"
            >
              <div className="flex items-center gap-2 mb-3">
                <MessageCircle className="w-5 h-5 text-blue-600" />
                <span className="text-base font-semibold text-slate-900">{t("feedbackTitle")}</span>
              </div>
              <p className="text-sm text-slate-500 leading-relaxed mb-3 flex-1">
                {t("feedbackDesc")}
              </p>
              <span className="inline-flex items-center gap-1 text-sm text-blue-600 font-medium group-hover:gap-2 transition-all">
                {t("feedbackEmail")}
                
              </span>
            </a>

            {/* Support card */}
            <a
              href={`mailto:${t("supportEmail")}`}
              onClick={() => copyEmail(t("supportEmail"))}
              className="group flex flex-col p-8 rounded-2xl border border-slate-200 bg-white hover:border-blue-300 hover:shadow-md transition-all min-h-[220px]" 
              >
              <div className="flex items-center gap-2 mb-3">
                <Mail className="w-5 h-5 text-blue-600" />
                <span className="text-base font-semibold text-slate-900">{t("supportTitle")}</span>
              </div>
              <p className="text-sm text-slate-500 leading-relaxed mb-3 flex-1">
                {t("supportDesc")}
              </p>
              <span className="inline-flex items-center gap-1 text-sm text-blue-600 font-medium group-hover:gap-2 transition-all">
                {t("supportEmail")}
               
              </span>
            </a>
          </div>
        </div>

        {/* Energy section */}
       {/* <div className="rounded-2xl bg-gradient-to-br from-blue-50 via-sky-50 to-blue-50 border border-blue-100 p-6 lg:p-10">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-9 h-9 rounded-xl bg-blue-600 text-white flex items-center justify-center">
              <Zap className="w-5 h-5" />
            </div>
            <h2 className="text-xl lg:text-2xl font-semibold text-slate-900">
              {t.energyTitle}
            </h2>
          </div>
          <p className="text-sm text-slate-600 mb-6 max-w-2xl">{t.energySub}</p>

          <div className="grid sm:grid-cols-2 gap-3">
            {t.rows.map((row, idx) => (
              <div
                key={idx}
                className="flex items-center justify-between p-3 rounded-xl bg-white/70 border border-blue-100"
              >
                <span className="text-sm text-slate-700">{row.action}</span>
                <span className="text-sm font-semibold text-blue-700 font-mono">{row.energy}</span>
              </div>
            ))}
          </div>

          <p className="text-[11px] text-slate-400 mt-6">{t.energyDisclaimer}</p>
        </div> */}

        {/* Home button */}
        <div className="mt-12 text-center">
          <Link
            href="/"
            className="inline-block px-6 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-medium hover:bg-slate-700 transition-colors"
          >
            {t("home")}
          </Link>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
}